import type { Column } from "@shared/types/data-table"
import type { Plan } from "@/features/subscriptions/types/plans/plan.types"
import type { ColumnManagementConfig } from "@shared/lib/tables/utils/column-management"
import {
  createTextColumn,
  createStatusColumn,
  createCustomColumn,
  createDateColumn,
} from "./column-factories"

export const PLAN_COLUMNS: Record<string, Column<Plan>> = {
  name: createTextColumn<Plan>("name", "Plan", 200, "font-medium"),
  status: createStatusColumn<Plan>("plan"),
  description: createTextColumn<Plan>("description", "Description", 300),
  arr: createTextColumn<Plan>("arr", "ARR", 120),
  subscriptions: createCustomColumn<Plan>(
    "subscriptions",
    "Subscriptions",
    120,
    (plan: Plan) => (
      <span>
        {typeof plan.subscriptions === 'number'
          ? plan.subscriptions.toLocaleString()
          : plan.subscriptions}
      </span>
    )
  ),
  created: createDateColumn<Plan>("created", "Created", 150, false),
}

const PLAN_STATUS_CONFIG = {
  all: ['name', 'status', 'description', 'arr', 'subscriptions', 'created'],
  active: ['name', 'status', 'description', 'arr', 'subscriptions', 'created'],
  draft: ['name', 'status', 'description', 'arr', 'subscriptions', 'created'],
  archived: ['name', 'status', 'description', 'arr', 'subscriptions', 'created'],
} as const

export const getPlanColumns = (status: string = 'all'): Column<Plan>[] => {
  const keys = PLAN_STATUS_CONFIG[status as keyof typeof PLAN_STATUS_CONFIG] || PLAN_STATUS_CONFIG.all
  return keys.map(key => PLAN_COLUMNS[key]).filter(Boolean)
}

export const getPlanColumnConfig = (status: string = 'all'): ColumnManagementConfig[] => {
  const visibleKeys: Set<string> = new Set(PLAN_STATUS_CONFIG[status as keyof typeof PLAN_STATUS_CONFIG] || PLAN_STATUS_CONFIG.all)
  return Object.entries(PLAN_COLUMNS).map(([key, col], index) => ({
    id: col.key,
    label: typeof col.header === 'string' ? col.header : col.key,
    visible: visibleKeys.has(key),
    required: ['name', 'status'].includes(key),
    order: index
  }))
}
